<template>
  <g v-if="isVisible">
    <polyline
      :id="id"
      :points="pointsStr"
      :marker-end="markerEnd"
      stroke-width="1"
      fill="transparent"
      class="flow__arrow"
      :class="{ 'flow__arrow-dragging': arrowDragging }"
    />
  </g>
</template>

<script>
import DesignerMixin from "../../../DesignerMixin";
import { RADIUS } from "./ElementUtils";
export default {
  mixins: [DesignerMixin],
  props: ["id", "attributes", "startShapeId", "endShapeId"],
  data() {
    return {
      pointsStr: "", // all points in str format used for polyline points attribute
    };
  },
  computed: {
    isVisible() {
      return (
        this.getRowVisibility(this.startShapeId.replace("activity_", "")) &&
        this.getRowVisibility(this.endShapeId.replace("activity_", ""))
      );
    },
    markerEnd() {
      return this.arrowDragging ? "url(#arrowDrag)" : "url(#arrow)";
    },
    arrowDragging() {
      return this.$store.state.customFlow.arrowDraggingId === this.id;
    },
    startShape() {
      return this.$store.state.customFlow.shapeMap[this.startShapeId];
    },
    endShape() {
      return this.$store.state.customFlow.shapeMap[this.endShapeId];
    },
  },
  watch: {
    attributes() {
      this.setInitialData(this.attributes);
    },
    startShape: {
      handler: function (val, oldVal) {
        this.setStartPointPosition();
        this.setEndPointPosition();
        this.pointsStr = this.getPointStr(this.attributes);
      },
      deep: true,
    },
    endShape: {
      handler: function (val, oldVal) {
        this.setStartPointPosition();
        this.setEndPointPosition();
        this.pointsStr = this.getPointStr(this.attributes);
      },
      deep: true,
    },
  },
  mounted() {
    this.setInitialData(this.attributes);
  },
  methods: {
    getPointStr(points) {
      return points.reduce((prev, current) => prev + current[0] + " " + current[1] + " ", "");
    },
    setInitialData() {
      this.pointsStr = this.getPointStr(this.attributes);
    },

    setStartPointPosition() {
      const startShapeX = this.startShape.attributes.cx;
      const startShapeY = this.startShape.attributes.cy;
      const endShapeX = this.endShape.attributes.cx;
      const endShapeY = this.endShape.attributes.cy;

      const changingPointStart = this.attributes[1];
      const changingPointEnd = this.attributes[2];

      const firstPoint = this.attributes[0];
      // if center
      if (Math.abs(this.attributes[1][0] - startShapeX) < RADIUS + 4) {
        if (startShapeY < endShapeY) {
          changingPointStart[0] = startShapeX;
          changingPointStart[1] = startShapeY + RADIUS;
          firstPoint[0] = startShapeX;
          firstPoint[1] = startShapeY + RADIUS;
          changingPointEnd[0] = startShapeX;
        } else {
          changingPointStart[0] = startShapeX;
          changingPointStart[1] = startShapeY - RADIUS;
          firstPoint[0] = startShapeX;
          firstPoint[1] = startShapeY - RADIUS;
          changingPointEnd[0] = startShapeX;
        }
      }
      // if to right
      else if (changingPointStart[0] > startShapeX) {
        if (firstPoint[1] === startShapeY + RADIUS || firstPoint[1] === startShapeY) {
          changingPointStart[1] = startShapeY;
          firstPoint[0] = startShapeX + RADIUS;
          firstPoint[1] = startShapeY;
        } else {
          // only change x if it is not in the middle of circle.(12, 3, 6, 9)
          firstPoint[0] = startShapeX + RADIUS - 2;
        }
      } // if to left
      else {
        if (firstPoint[1] === startShapeY + RADIUS || firstPoint[1] === startShapeY) {
          changingPointStart[1] = startShapeY;
          firstPoint[0] = startShapeX - RADIUS;
          firstPoint[1] = startShapeY;
        } else {
          firstPoint[0] = startShapeX - RADIUS + 2;
        }
      }
    },
    setEndPointPosition() {
      const startShapeX = this.startShape.attributes.cx;
      const startShapeY = this.startShape.attributes.cy;
      const endShapeX = this.endShape.attributes.cx;
      const endShapeY = this.endShape.attributes.cy;
      const changingPointEnd = this.attributes[2];
      const lastPoint = this.attributes[this.attributes.length - 1];
      const changingPointStart = this.attributes[1];
      // if center
      if (Math.abs(changingPointEnd[0] - endShapeX) < RADIUS + 4) {
        if (startShapeY < endShapeY) {
          changingPointEnd[0] = endShapeX;
          changingPointEnd[1] = endShapeY - RADIUS - 1;
          lastPoint[0] = endShapeX;
          lastPoint[1] = endShapeY - RADIUS;

          changingPointStart[0] = endShapeX;
        } else {
          changingPointEnd[0] = endShapeX;
          changingPointEnd[1] = endShapeY + RADIUS + 1;
          lastPoint[0] = endShapeX;
          lastPoint[1] = endShapeY + RADIUS;

          changingPointStart[0] = endShapeX;
        }
      }
      // if to right
      else if (this.attributes[2][0] > endShapeX) {
        if (lastPoint[1] === endShapeY - RADIUS || lastPoint[1] === endShapeY) {
          changingPointEnd[1] = endShapeY;
          lastPoint[0] = endShapeX + RADIUS;
          lastPoint[1] = endShapeY;
        } else {
          lastPoint[0] = endShapeX + RADIUS - 2;
        }
      } // if to left
      else {
        if (lastPoint[1] === endShapeY - RADIUS || lastPoint[1] === endShapeY) {
          changingPointEnd[1] = endShapeY;
          lastPoint[0] = endShapeX - RADIUS;
          lastPoint[1] = endShapeY;
        } else {
          lastPoint[0] = endShapeX - RADIUS + 2;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/variables";

.flow__arrow {
  stroke: @kk-color-primary-blue;
  &-dragging {
    stroke: hsl(205, 100%, 45%);
  }
}
</style>
